<div [class.faded]="loading" class="chart-container">
  @if (chartData) {
  <qa-chart
    [data]="chartData"
    [options]="chartOptions"
    (chartClick)="chartClicked($event)"
    chartType="bar"
    #chart
  >
  </qa-chart>
  }
</div>
